import { QueryDtoOf } from '@40seas/entities/common';
import { Invoice } from './invoice.entity';
import { Buyer } from '@40seas/entities/buyers';

export class QueryInvoiceDto extends QueryDtoOf(Invoice, [Buyer]) {}
